module.exports = __webpack_public_path__ + "img/p4.2312eb5a.png";